import { render, staticRenderFns } from "./JudgeSelector.vue?vue&type=template&id=d911cac0&scoped=true"
import script from "./JudgeSelector.vue?vue&type=script&lang=js"
export * from "./JudgeSelector.vue?vue&type=script&lang=js"
import style0 from "./JudgeSelector.vue?vue&type=style&index=0&id=d911cac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d911cac0",
  null
  
)

export default component.exports